module.exports = __webpack_public_path__ + "static/images/waybill-header.3gL3u2K.svg";